export enum ChatRoleEnum {
  User = 'user',
  Ai = 'ai',
}
